var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.block.platform == 1)?_c('SlideProductsDesktop',{attrs:{"block":_vm.block,"border-width":_vm.borderWidth,"numeration":true}}):_c('SlideProductsMobile',{attrs:{"block":_vm.block,"numeration":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }